class UserRelationships {
  userId

  constructor(userId) {
    this.userId = userId
  }

  get basePath() {
    return `/api/users/${this.userId}/companies`
  }

  get() {
    return Munio.$http.get(`${this.basePath}`)
  }

  maintain(company) {
    return Munio.$http.put(`${this.basePath}`, { company })
  }
}

export default UserRelationships
